export const BIZ = {
  name: "Velocity Detailing",
  phone: "250-460-6290",
  tel: "tel:+12504606290",
  sms: "sms:+12504606290?&body=Hi%20Velocity%20Detailing%2C%20I%27d%20like%20a%20quote%20for%20",
  email: "teamvelocitydetail@gmail.com",
  address: "1909 43 Street, Vernon, BC, Canada",
  maps: "https://www.google.com/maps/search/?api=1&query=1909+43+Street+Vernon+BC",
  instagram: "https://www.instagram.com/velocity_detailing_services_/",
  igHandle: "@velocity_detailing_services_",
  tiktok: "https://www.tiktok.com/@velocitydetailingvernon",
  tiktokHandle: "@velocitydetailingvernon",
  facebook: "https://www.facebook.com/search/top?q=Velocity%20detailing%20Vernon",
  facebookName: "Velocity detailing",
};

export const AREAS = ["Vernon", "Coldstream", "Armstrong", "Lumby", "Enderby", "Lake Country", "Kelowna", "Salmon Arm"];
export const PICKUP_AREAS = ["Vernon", "Coldstream"];

export const PRICING = [
  {
    id: "interior", label: "Interior", title: "Interior Detailing",
    items: [
      { name: "Refresh Clean", price: "from $169" },
      { name: "Showroom Ready", price: "from $289" },
      { name: "Ultimate Icon", price: "from $449" },
      { name: "Heavy pet hair removal", price: "from $25 extra" },
    ],
  },
  {
    id: "package", label: "Int + Ext", title: "Interior & Exterior Package",
    note: "Includes premium interior detailing, exterior decontamination and a 6-month paint sealant.",
    items: [
      { name: "Sedan", price: "from $249" },
      { name: "SUV", price: "from $299" },
    ],
  },
  {
    id: "express", label: "Express", title: "Express Maintenance Detail",
    items: [
      { name: "Sedan / midsize SUV", price: "$49.99" },
      { name: "XL SUV / truck", price: "$59.99" },
      { name: "Add 3-month spray ceramic protection", price: "$19.99" },
    ],
  },
  {
    id: "tint", label: "Window Tint", title: "Nano-Ceramic Window Tint",
    note: "Premium nano-ceramic film, professional installation. Heat rejection, blocks up to 99% of UV rays, added privacy. Lifetime warranty against fading, discoloration, bubbling and delamination.",
    items: [
      { name: "Sedan — full tint", price: "$350", detail: "All side windows + rear window" },
      { name: "Pickup truck — full tint", price: "$350", detail: "All side windows + rear window" },
      { name: "SUV (5 seater) — full tint", price: "$400", detail: "All side windows + rear window" },
      { name: "SUV (7 seater) — full tint", price: "$450", detail: "All side windows + rear window" },
      { name: "Front 2 windows", price: "from $199", detail: "Driver + passenger front windows" },
      { name: "Full windshield", price: "$250", detail: "Nano-ceramic windshield tint" },
      { name: "Sun strip", price: "$79" },
      { name: "Rear only (sedan)", price: "$200" },
      { name: "Rear only (SUV 7 seater)", price: "$260" },
      { name: "Quarter window (each)", price: "$50" },
    ],
  },
  {
    id: "ppf", label: "PPF", title: "Paint Protection Film",
    items: [
      { name: "Front protection package", price: "from $1,299", detail: "Partial hood, partial front fenders, full front bumper, mirrors and door cups." },
      { name: "Full front-end and custom coverage", price: "Request a quote" },
    ],
  },
  {
    id: "ceramic", label: "Ceramic", title: "Ceramic Coatings",
    note: "Includes Stage 1 paint polishing and two complimentary maintenance washes. Additional paint correction available.",
    items: [
      { name: "1-year coating", price: "Request a quote" },
      { name: "2-year coating", price: "Request a quote" },
      { name: "5-year coating", price: "Request a quote" },
    ],
  },
  {
    id: "correction", label: "Correction", title: "Paint Correction",
    items: [
      { name: "Single-stage correction", price: "Request a quote" },
      { name: "Two-stage correction", price: "Request a quote" },
      { name: "Multi-stage correction", price: "Request a quote" },
    ],
  },
  {
    id: "marine", label: "Marine", title: "Marine Detailing",
    items: [
      { name: "One-stage gelcoat polish + 1-year marine sealant", price: "from $599" },
      { name: "Two-stage gelcoat polish + marine sealant", price: "from $799" },
      { name: "Aluminum boat cleaning & interior detailing", price: "Request a quote" },
    ],
  },
  {
    id: "rv", label: "RV", title: "RV / Motorhome Detailing",
    items: [
      { name: "Wash and wax, 20–45 ft RVs & motorhomes", price: "$349" },
      { name: "Oxidation removal, polishing & roof services", price: "Request a quote" },
    ],
  },
  {
    id: "addons", label: "Add-ons", title: "Add-ons",
    items: [
      { name: "Engine bay wash", price: "$20" },
      { name: "Engine bay detail", price: "$35" },
      { name: "Spray wax", price: "$50" },
      { name: "Iron removal", price: "$50" },
      { name: "Seat shampoo", price: "from $59.99" },
    ],
  },
  {
    id: "other", label: "More", title: "Other Services",
    note: "All quoted individually.",
    items: [
      { name: "Undercoating & rust protection", price: "Request a quote" },
      { name: "Vinyl wraps & decals", price: "Request a quote" },
      { name: "Chrome & wheel polishing", price: "Request a quote" },
      { name: "Fleet detailing & maintenance plans", price: "Request a quote" },
      { name: "Spray-on bed liner", price: "Request a quote" },
      { name: "Caliper painting", price: "Request a quote" },
      { name: "Dash camera installation", price: "Request a quote" },
    ],
  },
];

export const SERVICE_OPTIONS = [
  "Interior Detailing", "Interior & Exterior Package", "Express Maintenance", "Window Tint",
  "Paint Protection Film", "Ceramic Coating", "Paint Correction", "Marine Detailing",
  "RV / Motorhome", "Undercoating", "Add-ons", "Other",
];

export const PRICING_TO_SERVICE = {
  interior: "Interior Detailing", package: "Interior & Exterior Package", express: "Express Maintenance",
  tint: "Window Tint", ppf: "Paint Protection Film", ceramic: "Ceramic Coating", correction: "Paint Correction",
  marine: "Marine Detailing", rv: "RV / Motorhome", addons: "Add-ons", other: "Other",
};
